import { assoc, prop } from 'ramda';
import { useState } from 'react';
import ResetPasswordMutation from '../_graphql/mutations/ResetPasswordMutation';
import ResetPasswordRequestMutation from '../_graphql/mutations/ResetPasswordRequestMutation';

const usePassword = (token) => {
  const [state, setState] = useState({
    email: '',
    password: '',
    loading: false,
    sent: false,
    error: false
  });

  const callback = (ok, error) => {
    if (error) {
      setState(assoc('error', true));
    }
    setState(assoc('loading', false));
    setState(assoc('sent', true));
  };

  const onRequestPassword = () => {
    setState(assoc('loading', true));
    ResetPasswordRequestMutation(prop('email', state), callback);
  };

  const onResetPassword = () => {
    setState(assoc('loading', true));
    ResetPasswordMutation({ token, password: prop('password', state) }, callback);
  };

  return {
    ...state,
    setState,
    onRequestPassword,
    onResetPassword
  };
};

export default usePassword;
